import { MODAL_AUTH_FORGOT_PASSWORD } from '@components/App/Modal/constants'
import { Button, ThemeColors } from '@octopus-do/octopus-storybook'
import { openModal } from '@storeOld/reducers/ui'
import { useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'

import { GtmTriggerName, sendGtmEvent } from '@/constants/gtm'
import { useForm } from '@/hooks'
import ContinueWithSocial from './ContinueWithSocial.jsx'
import './Register.css'
import { NestClient } from '@/nest'
import { AuthActions } from '@/store/reducers/auth'
import { clsJoin } from '@/utils'

// biome-ignore lint/suspicious/noShadowRestrictedNames: Error is a domain component name
const Error = ({ children }) => (
  <div className="Register__error">{children}</div>
)

const Login = (props) => {
  const navigate = useNavigate()
  const dispatch = useDispatch()

  const [state, setState] = useState({ isLoading: false })
  const { form, errors, register, onSubmit } = useForm()

  const handleSubmit = async (e) => {
    if (state.isLoading) {
      return
    }

    setState({ isLoading: true })

    try {
      const payload = await NestClient.auth.login({
        username: form.emailAddress,
        password: form.password,
      })

      // модалку закроет setTokenSaga, когда пользователь будет загружен —
      // до этого кнопка крутит спиннер и артборд под модалкой не мелькает
      if (props.redirectAfterAuth) {
        navigate(
          `?${new URLSearchParams({
            redirectAfterAuth: encodeURIComponent(props.redirectAfterAuth),
          })}`,
          { replace: true }
        )
      }

      dispatch(AuthActions.setToken(payload.token))

      // Log in succeeded — count it here, not on the submit click, so failed
      // logins don't inflate the count.
      sendGtmEvent(GtmTriggerName.AUTH_LOG_IN, 'Logged in')
    } catch (err) {
      const data = JSON.parse(err.message)
      setState({ isLoading: false, error: data.message })
      sendGtmEvent(GtmTriggerName.AUTH_LOG_IN_ERROR, data.message)
    }
  }

  return (
    <form
      className={clsJoin('Register__content', ThemeColors.light)}
      onSubmit={(e) => {
        onSubmit(e, handleSubmit)
      }}
    >
      <div className="Register__input">
        <input
          className="Clipboard-input"
          name="emailAddress"
          type="text"
          placeholder="Email"
          {...register(
            'emailAddress',
            '',
            {
              required: true,
              email: true,
            },
            () => {
              setState((prevState) => ({
                ...prevState,
                error: null,
              }))
            }
          )}
        />

        {state.error && <Error>{state.error}</Error>}

        {errors.emailAddress && <Error>{errors.emailAddress}</Error>}
      </div>

      <div className="Register__input">
        <input
          className="Clipboard-input"
          name="password"
          type="password"
          placeholder="Password"
          {...register('password', '', {
            required: true,
          })}
        />

        {errors.password && <Error>{errors.password}</Error>}
      </div>

      <LoginCommit
        isLoading={state.isLoading}
        onForgotClick={props.onForgotClick}
      />

      <ContinueWithSocial
        disabled={state.isLoading}
        redirectAfterAuth={props.redirectAfterAuth}
      />
    </form>
  )
}

const LoginCommit = (props) => (
  <div className="Register__commit">
    <div className="Register__btn">
      <Button type="submit" label="Log in" loading={props.isLoading} />
    </div>

    <div className="Register__reset">
      <span onClick={props.onForgotClick}>Forgot password?</span>
    </div>
  </div>
)

const mapDispatchToProps = (dispatch) => ({
  onForgotClick: () => dispatch(openModal(MODAL_AUTH_FORGOT_PASSWORD)),
})

export default connect(null, mapDispatchToProps)(Login)
